import {Pipe, PipeTransform} from "@angular/core";
import {TriagemPassagemService} from "../../../service/triagem-passagem.service";

@Pipe({
  name: 'totalReservadasPassagem',
  standalone: true
})
export class TotalReservadasPassagemPipe implements PipeTransform {

  transform(triagemPassagemService: TriagemPassagemService): number {
    return triagemPassagemService.infracoesAvaliarDepois$.value
      .getReservadasEmTela()
      .map((reservadasEmTela) => reservadasEmTela.numbers.length)
      .reduce((acc, value) => acc + value, 0);
  }

}
